<template>

    <div class="container register-page">
        <div class="row">
            <div class="offset-lg-3 col-lg-6 bg-ss-gray">
                <h2>{{ lang('all.wachtwoord_opnieuw_instellen') }}</h2>
                <text-input
                    label=""
                    type="email"
                    placeholder="E-mailadres"
                    v-model="form.email"
                    :errors="errors.email"
                ></text-input>

                <text-input
                    label=""
                    type="password"
                    :placeholder="lang('all.gewenst_wachtwoord')"
                    v-model="form.password"
                    :errors="errors.password"
                ></text-input>

                <text-input
                    label=""
                    type="password"
                    :placeholder="lang('all.wachtwoord_bevestigen')"
                    v-model="form.password_confirmation"
                ></text-input>

                <button
                    class="btn btn-primary float-right"
                    :disabled="!canChangePassword"
                    @click="changePassword"
                >
                    {{ lang('all.wachtwoord_instellen') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import TextInput from "../../Common/TextInput";

export default {

    components: {
        TextInput,
    },

    computed: {
        canChangePassword() {
            return this.posting === false &&
                this.form.email !== '' &&
                this.form.password !== '' &&
                this.form.password_confirmation === this.form.password;
        },
        errors() {
            return this.$page.props.errors;
        },
    },

    data() {
        return {
            form: {
                email:'',
                password:'',
                password_confirmation:'',
            },
            posting:false,
        }
    },

    layout:Layout,

    metaInfo: {
        title: 'Wachtwoord opnieuw instellen'
    },

    methods: {
        changePassword() {
            if (!this.canChangePassword) {
                return;
            }
            this.posting = true;
            this.$inertia.post(this.route('guest.password.update'), this.form, {
                onFinish: () => this.posting = false,
            });
        }
    },

    mounted() {
        this.form.email = JSON.parse(JSON.stringify(this.email));
        this.form.token = JSON.parse(JSON.stringify(this.token));
    },

    name:'GuestResetPassword',

    props: {
        email:{
            required:true,
            type:String,
        },
        token:{
            required:true,
        },
    }

}

</script>
